import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  content: {
    paddingBottom: theme.spacing(2),
  },
  formHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  infoHeader: {
    display: "flex",
    alignItems: "center",
    "& h3": {
      margin: "0 8px",
    },
  },
  header: {
    display: "flex",
    marginLeft: 18,
    alignItems: "center",
  },
  calendar: {
    display: "flex",
    padding: "0 18px",
    alignItems: "center",
    borderLeft: `1px solid ${theme.color.gray2}`,
    borderRight: `1px solid ${theme.color.gray2}`,
    color: theme.color.gray5,
    fontSize: 14,
    marginRight: 18,
  },
  calendarIcon: {
    width: 18,
    marginRight: theme.spacing(1),
  },
  switchButton: {
    "& span": {
      fontSize: 14,
    },
  },
  topBlock: {
    height: "100%",
    "& .about": {
      display: "flex",
      "& .left, & .right": {
        flex: 1,
      },
      "& .left": {
        paddingRight: "10px",
      },
      "& .right": {
        marginLeft: "10px",
      },
      "& table": {
        width: "100%",
        borderSpacing: `0 ${theme.spacing(2)}px`,
      },
      "& .label": {
        color: "#2D2D2D",
        width: "50%",
        verticalAlign: "top",
      },
      "& .data": {
        color: "#030F85",
        fontWeight: "bold",
        width: "50%",
        verticalAlign: "top",
      },
    },
  },
  companyInfos: {
    alignSelf: "stretch",
    "& .about": {
      "& .left": {
        borderRight: `solid 1px ${theme.color.gray2}`,
      },
    },
    flex: 2,
  },
  topRightBlock: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  toolsMenu: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  materialBlock: {
    "& td.data.right": {
      textAlign: "right",
      "& button": {
        minWidth: 178,
      },
    },
    "& .rowMenu": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "& button": {
        minWidth: 178,
      },
    },
  },
  fullWidthContainer: {
    width: "100%",
    marginTop: theme.spacing(2),
    // Styles pour les boutons d'ajout dans les containers
    "& .MuiButton-root": {
      color: "#000000 !important",
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "#f5f5f5 !important",
        color: "#000000 !important",
        boxShadow: "none !important",
      },
      "&:disabled": {
        color: "#cccccc !important",
        backgroundColor: "transparent !important",
      },
    },
  },
  warehouseTables: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  warehouseTableTitle: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  noPaddingTable: {
    padding: "0 !important",
  },
  companyStats: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  cellContainer: {
    cursor: "pointer",
  },
  addWarehouseBtn: {
    // Tweaks to align it with "Ajouter un contact" above
    marginRight: `${theme.spacing(7)}px !important`,
    // Styles pour le bouton "Ajouter un entrepôt"
    color: "#000000 !important",
    backgroundColor: "transparent !important",
    boxShadow: "none !important",
    border: "none !important",
    transition: "background-color 0.2s ease !important",
    "&:hover": {
      backgroundColor: "#f5f5f5 !important",
      color: "#000000 !important",
      boxShadow: "none !important",
    },
    "&:disabled": {
      color: "#cccccc !important",
      backgroundColor: "transparent !important",
      pointerEvents: "none",
    },
    "&:focus": {
      backgroundColor: "#f5f5f5 !important",
      outline: "none",
    },
  },
  disabledCta: {
    color: "rgba(0, 0, 0, 0.37) !important",
    pointerEvents: "none",
  },
  hasTypeBeforeAlert: {
    margin: `${theme.spacing(2)}px 0`,
  },
  // Classe optionnelle pour d'autres boutons d'ajout
  addButton: {
    color: "#000000 !important",
    backgroundColor: "transparent !important",
    boxShadow: "none !important",
    border: "none !important",
    transition: "background-color 0.2s ease !important",
    "&:hover": {
      backgroundColor: "#f5f5f5 !important",
      color: "#000000 !important",
      boxShadow: "none !important",
    },
    "&:disabled": {
      color: "#cccccc !important",
      backgroundColor: "transparent !important",
      pointerEvents: "none",
    },
    "&:focus": {
      backgroundColor: "#f5f5f5 !important",
      outline: "none",
    },
  },
}));
